export const attendanceRecordRouting = [
  {
    path: "/attendance/record/list",
    name: "attendance-record-list",
    meta: { title: "考勤原始记录" },
    component: () =>
      import(/* webpackChunkName: "attendance-leave" */ "@/views/attendance-management/attendance-record/list/list.vue"),
  },
	// {
	// 	hidden:true,
	//   path: "/attendance/leave/create",
	//   name: "attendance-leave-create",
	//   meta: { title: "新建请假申请" },
	//   component: () =>
	//     import(/* webpackChunkName: "attendance-leave" */ "@/views/attendance-management/leave-application/form/form.vue"),
	// },
	// {
	// 	hidden:true,
	//   path: "/attendance/leave/edit/:id",
	//   name: "attendance-leave-edit",
	//   meta: { title: "编辑请假申请" },
	//   component: () =>
	//     import(/* webpackChunkName: "attendance-leave" */ "@/views/attendance-management/leave-application/form/form.vue"),
	// },
	// {
	// 	hidden:true,
	//   path: "/attendance/leave/detail/:id",
	//   name: "attendance-leave-detail",
	//   meta: { title: "请假申请详情" },
	//   component: () =>
	//     import(/* webpackChunkName: "attendance-leave" */ "@/views/attendance-management/leave-application/detail/detail.vue"),
	// },
]